(function(){

  'use strict';

  // **********************************
  //  Data that this directive needs
  // ----------------------------------
  //
  //

  function pxRootCreate(
    SitesProviderService, $rootScope, CopilotService
  ) {
    return {
      restrict: 'EA',
      scope: {
        rootCreateData: '=rootCreateData',
        callback: '&callback'
      },
      templateUrl: 'app/components/sites/rootCreate/rootCreate.template.html',
      link: function(scope, element) {

        scope.itemName = scope.rootCreateData.itemName || '';
        scope.invalidInput = scope.itemName.length === 0;

        (function() {
          init();
          setPosition();
          setListeners();
        })();

        scope.$watch(function () {
          return scope.rootCreatePopupObject;
        }, function (oldVal, newVal) {
          setPosition();
          init();
        });

        function init() {
          element.on("keydown keypress", function (event) {
            if(event.which === 13) {
              event.preventDefault();
              scope.$apply(function (){
                if (!scope.invalidInput) {
                  scope.createRootSiteTreeItem();
                }
              });
            }
          });
        }

        function setPosition () {
          angular.element('.root-create').css({left: scope.rootCreateData.position.left, top: scope.rootCreateData.position.top});
        }

        scope.closePopupOnClickOutside = function () {
          // Do not close the popup on outside click if the Copilot is active
          // because the user might be interacting with the chat window
          if (!CopilotService.state.chatOpen) {
            scope.closePopup();
          }
        }

        scope.closePopup = function () {
          scope.invalidInput = true;
          element.off("keydown keypress")
          scope.callback();
        }

        scope.validateName = function( ) {
          if (scope.itemName.length <= 0) {
            scope.invalidInput = true;
          } else {
            scope.invalidInput = false;
          }
        }

        scope.createRootSiteTreeItem = function() {
          scope.closePopup();
          SitesProviderService.createSiteTreeRootItem(scope.itemName, scope.rootCreateData.type).then(function(response) {
          }).catch(function(error){});
        }

        function setListeners () {
          // $rootScope.$on('FORCE_CLOSE_UNSCOPED_MENUS', function () {
          //   scope.closePopup();
          // });
        }
        var FORCE_CLOSE_UNSCOPED_MENUS_listener = $rootScope.$on('FORCE_CLOSE_UNSCOPED_MENUS', function () {
          scope.closePopup();
        });

        scope.$on('$destroy', function() {
          FORCE_CLOSE_UNSCOPED_MENUS_listener();
        });

      }
    };
  }

  pxRootCreate.$inject = ['SitesProviderService', '$rootScope', 'CopilotService'];

  angular
    .module('printix-admin')
    .directive('pxRootCreate', pxRootCreate);

})();